export default {
    state: {
        showSidenav: false,
        showNavbar: false,
        showFooter: false,
        showMain: false,
    },
    getters: {
        getShowSidenav(state) {
            return state.showSidenav;
        },
        getShowNavbar(state) {
            return state.showNavbar;
        },
        getShowFooter(state) {
            return state.showFooter;
        },
        getMain(state) {
            return state.main;
        }
    },
    mutations: {
        setShowSidenavMutation(state, value) {
            state.showSidenav = value;
        },
        setShowNavbarMutation(state, value) {
            state.showNavbar = value;
        },
        setShowFooterMutation(state, value) {
            state.showFooter = value;
        },
        setShowMainMutation(state, value) {
            state.showMain = value;
        },
        setAllLayoutValuesNullMutation(state) {
            state.showSidenav = false;
            state.showNavbar = false;
            state.showFooter = false;
            state.showMain = false;
        }
    }
}